import { rightMini } from "assets/icons";
import styled from "@emotion/styled";
import { Typography } from "antd";
import React, { FC } from "react";
import { ContactByIdResponse } from "services/interface";
import moment from "moment";

interface HandshackeAgentProps {
  data: ContactByIdResponse | undefined;
}

const HandshackeAgent: FC<HandshackeAgentProps> = ({ data }) => {
  return (
    <>
      <ContentWrapper>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            เป็นตัวแทนเมื่อวันที่{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {moment(data?.conjugate.handshake_date).format("LL")}
          </Typography.Text>
        </WrapperText>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            คำสั่งซื้อที่เสร็จสิ้นแล้ว{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {data?.conjugate.total_completed_order} รายการ
          </Typography.Text>
        </WrapperText>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            คำสั่งซื้อที่ยังไม่เสร็จสิ้น{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {data?.conjugate.total_pending_order} รายการ
          </Typography.Text>
        </WrapperText>
        <WrapperFooter>
          <Typography.Text style={{ fontWeight: 400, marginTop: 5 }}>
            {" "}
            ดูประวัติคำสั่งซื้อ
          </Typography.Text>
          <IconWrapper>
            <SpanIcon>{rightMini}</SpanIcon>
          </IconWrapper>
        </WrapperFooter>
      </ContentWrapper>
    </>
  );
};

export default HandshackeAgent;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  width: 100%;
  height: 100%;
`;

const WrapperFooter = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  width: 100%;
  height: 100%;
  border-top: 1px solid #efefef;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 20px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-top: 5px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
